var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKenFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16451_134226)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.726562,
    y: 0.617188,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_16451_134226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.25 -3.29297H28.75V28.707H-3.25V-3.29297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.25 -3.29297H28.75V6.30703H-3.25V-3.29297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.25 19.1074H28.75V28.7074H-3.25V19.1074Z",
    fill: "#006600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46094 22.2078L8.73094 22.4078L15.7359 6.20781C16.1409 6.08781 16.3659 5.56781 16.5909 5.04781C16.7409 4.68781 17.3409 3.30781 17.5959 1.50781C16.8843 2.35099 16.2813 3.3442 15.8109 4.44781C15.5859 4.96781 15.3609 5.48781 15.4659 6.02781L8.46094 22.2078Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.375,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46094 22.2078L8.73094 22.4078L15.7359 6.20781C16.1409 6.08781 16.3659 5.56781 16.5909 5.04781C16.7409 4.68781 17.3409 3.30781 17.5959 1.50781C16.8843 2.35099 16.2813 3.3442 15.8109 4.44781C15.5859 4.96781 15.3609 5.48781 15.4659 6.02781L8.46094 22.2078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0391 22.2078L16.7691 22.4078L9.76406 6.20781C9.35906 6.08781 9.13406 5.56781 8.90906 5.04781C8.75906 4.68781 8.15906 3.30781 7.90406 1.50781C8.6157 2.35099 9.21871 3.3442 9.68906 4.44781C9.91406 4.96781 10.1391 5.48781 10.0341 6.02781L17.0391 22.2078Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.375,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0391 22.2078L16.7691 22.4078L9.76406 6.20781C9.35906 6.08781 9.13406 5.56781 8.90906 5.04781C8.75906 4.68781 8.15906 3.30781 7.90406 1.50781C8.6157 2.35099 9.21871 3.3442 9.68906 4.44781C9.91406 4.96781 10.1391 5.48781 10.0341 6.02781L17.0391 22.2078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7772 7.90742H15.6022C15.1522 6.30742 13.6522 3.10742 12.7522 3.10742C11.8522 3.10742 10.3522 6.30742 9.90219 7.90742H-3.25781V17.5074H9.90219C10.3522 19.1074 11.8522 22.3074 12.7522 22.3074C13.6522 22.3074 15.1522 19.1074 15.6022 17.5074H28.7772V7.90742Z",
    fill: "#BB0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6016 17.5062C16.0516 15.9062 16.3516 14.3062 16.3516 12.7062C16.3516 11.1062 16.0516 9.50625 15.6016 7.90625C15.1516 9.50625 14.8516 11.1062 14.8516 12.7062C14.8516 14.3062 15.1516 15.9062 15.6016 17.5062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89844 17.5062C9.44844 15.9062 9.14844 14.3062 9.14844 12.7062C9.14844 11.1062 9.44844 9.50625 9.89844 7.90625C10.3484 9.50625 10.6484 11.1062 10.6484 12.7062C10.6484 14.3062 10.3484 15.9062 9.89844 17.5062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7484 13.9059C13.0798 13.9059 13.3484 13.3686 13.3484 12.7059C13.3484 12.0431 13.0798 11.5059 12.7484 11.5059C12.4171 11.5059 12.1484 12.0431 12.1484 12.7059C12.1484 13.3686 12.4171 13.9059 12.7484 13.9059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8984 13.8691C12.8984 13.8691 13.4984 15.4691 13.4984 18.0691C13.4984 20.6691 12.8984 22.2691 12.8984 22.2691V13.8691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6016 11.5488C12.6016 11.5488 12.0016 9.94883 12.0016 7.34883C12.0016 4.74883 12.6016 3.14883 12.6016 3.14883V11.5488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6016 13.8691C12.6016 13.8691 12.0016 15.4691 12.0016 18.0691C12.0016 20.6691 12.6016 22.2691 12.6016 22.2691V13.8691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8984 11.5488C12.8984 11.5488 13.4984 9.94883 13.4984 7.34883C13.4984 4.74883 12.8984 3.14883 12.8984 3.14883V11.5488Z",
    fill: "white"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.22656,
    y: 1.11719,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#E0E0E0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16451_134226"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.726562,
    y: 0.617188,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_16451_134226"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3.25,
    y: -3.29297,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKenFlag);
export default __webpack_public_path__ + "static/media/ken_flag.419777a819b87b3195d94c1ddcca756e.svg";
export { ForwardRef as ReactComponent };